import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewChildren
} from '@angular/core';
import {HttpService} from '../../../core';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-customer-contact',
  templateUrl: 'customer-contact.component.html',
  styleUrls: ['customer-contact.component.scss']
})
export class CustomerContactComponent implements OnInit, AfterViewChecked {
  allSalesArray = [];
  selectedSaleIdArray = [];
  tabIndex = 0;
  agentSelected = 0;
  projectId: string;
  SERVER_URL = environment.SERVER_URL;
  searchInput = '';
  @ViewChildren('matCheckbox') matCheckbox: any;
  sellersRandomType: number;
  projectDetail: any;
  pageIndex: number;
  pageSize: number;
  length: number;
  totalElements: number;
  pageSizeOptions: number[] = [10, 25, 50, 100];
  selectedSales = [];
  savedType: number;
  autoApprove: boolean;
  showNoAgents = false;
  @Input() project;


  constructor(private httpService: HttpService, private route: ActivatedRoute, private cdRef: ChangeDetectorRef, private toastrService: ToastrService) {
    this.projectId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    const data = {
      id: 'aaa',
      firstName: 'No',
      lastName: 'Agent',
      company: {
        name: 'Display no agent'
      },
      contacts: [
        {
          content: 'Display no agent'
        }
      ]
    };
    if (this.project) {
      this.projectDetail = this.project;
      this.sellersRandomType = this.project.sellersRandomType;
      this.savedType = this.project.sellersRandomType;
      if (this.project.sellersRandomType === 2) {
        this.tabIndex = 0;
        this.showNoAgents = false;
      } else {
        this.tabIndex = 0;
        this.showNoAgents = true;
      }
      this.autoApprove = this.project.autoApprove;
      this.httpService.getSales(this.projectId, 0, 10, '').toPromise().then((salesList: any) => {
        console.log(salesList);
        this.allSalesArray = salesList.data.content;
        this.allSalesArray.push(data);
        this.length = salesList.data.totalElements;
        this.pageIndex = salesList.data.number;
        this.pageSize = salesList.data.size;
        this.totalElements = salesList.data.totalElements;
        console.log(salesList.data);
        if (this.project.sellers && Object.keys(this.project.sellers).length > 0) {
          for (const eachAgency of this.project.sellers) {
            this.selectedSaleIdArray.push(eachAgency.id);
            this.selectedSales.push(eachAgency);
            console.log('---selected sales---', this.selectedSales);
            console.log('---elected sale id array---', this.selectedSaleIdArray);
            // console.log('---get all sales---', this.allSalesArray);
            this.agentSelected++;
          }
        } else {
          this.selectedSaleIdArray.push(data.id);
          console.log('---elected sale id array---', this.selectedSaleIdArray);
        }
      });
    } else {
      this.httpService.getProjectDetailByProjectId(this.projectId).toPromise().then((projectDetail: any) => {
        console.log(projectDetail);
        this.projectDetail = projectDetail.data;
        this.sellersRandomType = projectDetail.data.sellersRandomType;
        this.savedType = projectDetail.data.sellersRandomType;
        if (projectDetail.data.sellersRandomType === 2) {
          this.tabIndex = 0;
          this.showNoAgents = false;
        } else {
          this.tabIndex = 0;
          this.showNoAgents = true;
        }
        this.httpService.getSales(this.projectId, 0, 10, '').toPromise().then((salesList: any) => {
          this.allSalesArray = salesList.data.content;
          this.allSalesArray.push(data);
          this.selectedSales.push(data);
          this.length = salesList.data.totalElements;
          this.pageIndex = salesList.data.number;
          this.pageSize = salesList.data.size;
          this.totalElements = salesList.data.totalElements;
          console.log(salesList.data);
          if (projectDetail.data.sellers && Object.keys(projectDetail.data.sellers).length > 0) {
            for (const eachAgency of projectDetail.data.sellers) {
              this.selectedSaleIdArray.push(eachAgency.id);
              this.selectedSales.push(eachAgency);
              console.log('---selected sales---', this.selectedSales);
              console.log('---elected sale id array---', this.selectedSaleIdArray);
              this.agentSelected++;
            }
          } else {
            this.selectedSaleIdArray.push(data.id);
            console.log('---elected sale id array---', this.selectedSaleIdArray);
          }
        });
      });
    }

  }

  getSalesByPage(pageSize, e) {
    this.httpService.getSales(this.projectId, e ? e.pageIndex : 0, e ? e.pageSize : pageSize, this.searchInput).toPromise().then((salesList: any) => {
      console.log(salesList.data);
      this.allSalesArray = salesList.data.content;
      console.log('---get all sales---', this.allSalesArray);
      this.length = salesList.data.totalElements;
      this.pageIndex = salesList.data.number;
      this.pageSize = salesList.data.size;
      this.totalElements = salesList.data.totalElements;
    });

  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  handleTabIndexChange(event) {
    if (this.tabIndex === 0) {
      this.tabIndex = 1;
    } else if (this.tabIndex === 1) {
      this.tabIndex = 0;
    }
  }

  handleChecked(event, eachAgency) {
    if (event.checked) {
      if (eachAgency.id !== 'aaa') {
        this.agentSelected++;
        this.selectedSaleIdArray.push(eachAgency.id);
        this.selectedSales.push(eachAgency);
        if (this.selectedSaleIdArray.includes('aaa')) {
          const index = this.selectedSaleIdArray.indexOf('aaa');
          this.selectedSaleIdArray.splice(index, 1);
          this.selectedSales.splice(this.selectedSales.indexOf(eachAgency), 1);
        }
        console.log('---elected sale id array---', this.selectedSaleIdArray);
        console.log('---selected sales---', this.selectedSales);
      } else if (eachAgency.id === 'aaa') {
        // this.agentSelected--;
        this.agentSelected = 0;
        this.selectedSaleIdArray = [];
        this.selectedSales = [];
        this.selectedSaleIdArray.push('aaa');
        this.selectedSales.push({
          id: 'aaa',
          firstName: 'No',
          lastName: 'Agent',
          company: {
            name: 'Display no agent'
          },
          contacts: [
            {
              content: 'Display no agent'
            }
          ]
        });
      } else {
        this.agentSelected--;
      }
    }
    if (!event.checked) {
      if (eachAgency.id !== 'aaa') {
        this.agentSelected--;
        const index = this.selectedSaleIdArray.indexOf(eachAgency.id);
        this.selectedSaleIdArray.splice(index, 1);
        this.selectedSales.splice(this.selectedSales.indexOf(eachAgency), 1);
        console.log('---elected sale id array---', this.selectedSaleIdArray);
        console.log('---selected sales---', this.selectedSales);
      }
      if (this.selectedSaleIdArray.length === 0) {
        this.selectedSaleIdArray.push('aaa');
        this.selectedSales.push({
          id: 'aaa',
          firstName: 'No',
          lastName: 'Agent',
          company: {
            name: 'Display no agent'
          },
          contacts: [
            {
              content: 'Display no agent'
            }
          ]
        });
      }
    }
  }


  handleCheckAll(event) {
    if (event.checked) {
      for (const eachAgency of this.allSalesArray) {
        if (!this.selectedSaleIdArray.includes(eachAgency.id)) {
          this.selectedSaleIdArray.push(eachAgency.id);
          this.selectedSales.push(eachAgency);
          // console.log('---selected sales---', this.selectedSales);
          // console.log('---elected sale id array---', this.selectedSaleIdArray);
          this.agentSelected++;
        }
      }
      for (const eachCheckbox of this.matCheckbox) {
        eachCheckbox.checked = true;
      }
    }
    if (!event.checked) {
      for (const eachAgency of this.allSalesArray) {
        if (this.selectedSaleIdArray.includes(eachAgency.id)) {
          console.log(eachAgency.id);
          console.log(this.selectedSaleIdArray);
          const index = this.selectedSaleIdArray.indexOf(eachAgency.id);
          console.log(index);
          this.selectedSaleIdArray.splice(index, 1);
          this.selectedSales.splice(this.selectedSales.indexOf(eachAgency), 1);
          // console.log('---selected sales---', this.selectedSales);
          // console.log('---elected sale id array---', this.selectedSaleIdArray);
          this.agentSelected--;
        }
      }
      for (const eachCheckbox of this.matCheckbox) {
        eachCheckbox.checked = false;
      }
    }
  }

  isCheckboxChecked(eachAgency) {
    return this.selectedSaleIdArray.includes(eachAgency.id);
  }

  handleSubmit(event) {
    this.httpService.getSales(this.projectId, 0, 10, this.searchInput).toPromise().then((salesList: any) => {
      this.allSalesArray = salesList.data.content;
      this.length = salesList.data.totalElements;
      this.pageIndex = salesList.data.number;
      this.pageSize = salesList.data.size;
      this.totalElements = salesList.data.totalElements;
    });
  }

  handleSave() {
    console.log('---selected sale id array---', this.selectedSaleIdArray);
    const fd = new FormData();
    // if (this.tabIndex === 0) {
    //   this.sellersRandomType = 2;
    // }
    if (this.selectedSaleIdArray.length !== 0) {
      for (const id of this.selectedSaleIdArray) {
        if (id === 'aaa') {
          // this.sellersRandomType = 1;
          fd.append('sellerIds', '');
        } else {
          this.sellersRandomType = 2;
          fd.append('sellerIds', id);
        }
      }
    } else {
      this.toastrService.error('Please select at least one');
      return;
    }
    // if (this.sellersRandomType === 2) {
    //   console.log(this.selectedSaleIdArray);
    //   if (this.selectedSaleIdArray.length !== 0) {
    //     for (const id of this.selectedSaleIdArray) {
    //       fd.append('sellerIds', id);
    //     }
    //   } else {
    //     fd.append('sellerIds', '');
    //   }
    //
    // }
    fd.append('sellersRandomType', this.sellersRandomType.toString());
    console.log('---random agent---', fd);
    this.httpService.updateSalesOfProjectById(this.projectId, fd).toPromise().then((result: any) => {
      this.savedType = result.data?.sellersRandomType;
      this.toastrService.success('Update Successfully');
    });
  }

  autoApproval(event) {
    this.httpService.changeProjectNeedApproval(this.projectId, {autoApprove: event.checked}).toPromise().then((result: any) => {

    });
  }
}
